import { cardRequestsService } from "../services/cardRequests.service";
import { show as showAlert } from "../../Notifications/actions/alert.actions";
import { message } from "../../../constants/app.constants";
import { cardRequestConstants, nameSpace, retrynameSpace, retryConstants, successConstants, successNameSpace } from "../constants/cardRequests.constants";
import { createRequestBody } from "../factories/cardRequests.factory";
import { reset } from "redux-form";

export const getAllCardRequests = (requestParams) => {
    return async (dispatch) => {
        dispatch(request(requestParams));
        try {
            const response = await cardRequestsService.getAllCardRequests(requestParams);
            response && dispatch(success(response));
        } catch (error) {
            dispatch(failure(error));
            dispatch(showAlert("danger", "Failed to get card requests", error ? error.message : message.GENERIC_ERROR));
        }
    };

    function request(request) {
        return { type: cardRequestConstants[`GET_${nameSpace}_REQUEST`], request };
    }
    function success(response) {
        return { type: cardRequestConstants[`GET_${nameSpace}_SUCCESS`], response };
    }
    function failure(error) {
        return { type: cardRequestConstants[`GET_${nameSpace}_FAILURE`], error };
    }
};

export const resetCardRequest = () => {
    return async (dispatch) => {
        dispatch(reset());
    };
    function reset() {
        return { type: cardRequestConstants[`VIEW_${nameSpace}_RESET`] };
    }
};

export const getCardRequest = (id) => {
    return async (dispatch) => {
        dispatch(reset());
        dispatch(request(id));
        try {
            const response = await cardRequestsService.getCardRequest(id);
            response && dispatch(success(response));
        } catch (error) {
            dispatch(failure(error));
            dispatch(showAlert("danger", "Failed to get card request", error ? error.message : message.GENERIC_ERROR));
        }
    };

    function request(request) {
        return { type: cardRequestConstants[`VIEW_${nameSpace}_REQUEST`], request };
    }
    function success(response) {
        return {
            type: cardRequestConstants[`VIEW_${nameSpace}_SUCCESS`],
            response,
        };
    }
    function failure(error) {
        return { type: cardRequestConstants[`VIEW_${nameSpace}_FAILURE`], error };
    }
    function reset() {
        return { type: cardRequestConstants[`VIEW_${nameSpace}_RESET`] };
    }
};

export const getCardStatus = (id) => {
    return async (dispatch) => {
        dispatch(request(id));
        try {
            const response = await cardRequestsService.getCardStatus(id);
            response && dispatch(success(response));
        } catch (error) {
            dispatch(failure(error));
            dispatch(showAlert("danger", "Failed to get status for selected request", error ? error.message : message.GENERIC_ERROR));
        }
    };

    function request() {
        return { type: cardRequestConstants[`GETSTATUS_${nameSpace}_REQUEST`] };
    }
    function success(response) {
        return {
            type: cardRequestConstants[`GETSTATUS_${nameSpace}_SUCCESS`],
            response,
        };
    }
    function failure(error) {
        return {
            type: cardRequestConstants[`GETSTATUS_${nameSpace}_FAILURE`],
            error,
        };
    }
};

export const createCardRequests = (values, history) => {
    const requestBody = createRequestBody(values);
    const configName = values.configName ? values.configName.name : null;
    const cardRequestType = values.cardRequestType && values.cardRequestType.value;
    return async (dispatch) => {
        dispatch(request(requestBody));
        try {
            const response = await cardRequestsService.createCardRequests(requestBody, configName, cardRequestType);
            dispatch(success(response));
            dispatch(reset("createcard"));
            dispatch(showAlert("success", "Card request sent successfully", response && response.responseMessage));
            dispatch(getAllCardRequests({ page: 1, pageSize: 10 }));
            dispatch(resetPost());

            dispatch(resetView());
            history.push("/card-requests");
        } catch (error) {
            dispatch(failure(error));
            dispatch(showAlert("danger", "Failed to send card request", error ? error.message : message.GENERIC_ERROR));
        }
    };

    function request() {
        return { type: cardRequestConstants[`POST_${nameSpace}_REQUEST`] };
    }
    function success(response) {
        return {
            type: cardRequestConstants[`POST_${nameSpace}_SUCCESS`],
            response,
        };
    }
    function failure(error) {
        return { type: cardRequestConstants[`POST_${nameSpace}_FAILURE`], error };
    }
    function resetPost() {
        return { type: cardRequestConstants[`POST_${nameSpace}_RESET`] };
    }
    function resetView() {
        return { type: cardRequestConstants[`VIEW_${nameSpace}_RESET`] };
    }
};

export const resetPost = () => {
    return { type: cardRequestConstants[`POST_${nameSpace}_RESET`] };
};

export const retryFailed = (id, action, history) => {
    return async (dispatch) => {
        dispatch(request(id));

        try {
            const response = await cardRequestsService.retryCardRequest(id, action);
            dispatch(success(response));
            dispatch(showAlert("success", null, `Card request ${action === "resend" ? "resend" : "retry"} successful`));
            dispatch(resetPost());
            // dispatch(getCardRequest(id));
            history.push("/card-requests");
        } catch (error) {
           
            dispatch(failure(error));
            if (error && error.message) {
                if (error.message === "Failed to retry card request: Card production in progress,retry after an hour") {
                    dispatch(showAlert("warning", null, "Card production in progress, retry after an hour"));
                } else {
                    dispatch(showAlert("danger", "Failed to retry card request", error ? error.message : message.GENERIC_ERROR));
                }
            }
        }
    };

    function request() {
        return { type: retryConstants[`POST_${retrynameSpace}_REQUEST`] };
    }
    function success(response) {
        return {
            type: retryConstants[`POST_${retrynameSpace}_SUCCESS`],
            response,
        };
    }
    function failure(error) {
        return { type: retryConstants[`POST_${retrynameSpace}_FAILURE`], error };
    }
    function resetPost() {
        return { type: retryConstants[`POST_${retrynameSpace}_RESET`] };
    }
};

export const sendSuccessCards = (id, action) => {
    return async (dispatch) => {
        dispatch(request(id));
        try {
            const response = await cardRequestsService.retryCardRequest(id, action);
            dispatch(success(response));

            dispatch(showAlert("success", null, "Prepared cards in the batch has been sent successfully"));

            dispatch(resetPost());

            // history.push("/card-requests");
        } catch (error) {
            dispatch(failure(error));
            dispatch(showAlert("danger", "Failed to send succesful batch card request", error ? error.message : message.GENERIC_ERROR));
        }
    };

    function request() {
        return { type: successConstants[`POST_${successNameSpace}_REQUEST`] };
    }
    function success(response) {
        return {
            type: successConstants[`POST_${successNameSpace}_SUCCESS`],
            response,
        };
    }
    function failure(error) {
        return { type: successConstants[`POST_${successNameSpace}_FAILURE`], error };
    }
    function resetPost() {
        return { type: successConstants[`POST_${successNameSpace}_RESET`] };
    }
};
